import React from "react";
import Select from "react-select";
import Toggle from "react-toggle";

import { Button, NumberLabel } from "aible";
import { isEnabled } from "utils/featureFlags";

import numeral from "numeral";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import RunPlot from "containers/RunPlot/RunPlot";
import ModelTileContainer from "containers/Tiles/ModelTile";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import RunFrontierContainer from "containers/FrontierSliders/RunFrontier";

import SuccessResults from "components/CreateWizard/Success/SuccessResults";
import DeployStepContainer from "containers/CreateWizard/Success/DeployStep";

import AibleStep from "components/CreateWizard/AibleStep";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ResultsGraph from "components/Results/ResultsGraph";
import ModelError from "components/Results/ModelError";

import ModelLoadingIndicator from "containers/Results/ModelLoadingIndicator";
import MetaDataTable from "components/FeatureChart/MetaDataTable";

import ProjectTitle from "components/UnifiedProject/ProjectTitle";
import ProjectHelpContainer from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";
import { UNIFIED_PROJECT_STEPS } from "containers/UnifiedProject/reducer";

import styles from "./style.module.css";

export const SECTIONS = {
  OVERVIEW: "Overview",
  RESULTS: "Results",
  ROI_CHART: "ROI Chart",
  PREDICTION_DRIVERS: "Prediction Drivers",
  WHAT_IF: "What If",
  MODEL_DETAILS: "Model Details"
};

export default class Results extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isHelpClosed: false, hideDetails: false, showModelFit: false };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  generateFids() {
    let ids = this.props.frontierModels && this.props.frontierModels.map((a) => a.id);
    return new Set(ids);
  }

  updateSelectedTab(key) {
    const { updateOption } = this.props;

    //return updateOption("selectedTab", key);
  }

  renderFeatureChartHeader() {
    const {
      model,
      models,
      updateChooseModel,
      modelIsAllowedInFrontier,
      setIsAllowedInFrontier,
      updateIgnoredModel,
      ignoredModels,
      isContinuous
    } = this.props;

    const fids = this.generateFids();

    const isModelFrontier = model ? fids.has(model.id) : false;
    const isIgnored = model && ignoredModels[model.id];

    const enableShowModelFitCheckbox = () => {
      return false;
      if (isEnabled("model-fit-chart") && model && model.metadata) {
        if (isContinuous && model.metadata.predicted_vs_actual && model.metadata.residual_plot) {
          return true;
        } else if (model.metadata.hosmer_lemeshow_plot) {
          return true;
        }
      }
      return false;
    };

    return (
      <div className={styles.fChartHeaderWrapper}>
        <div className={styles.optionHolder}>
          <Select
            options={models.map((m) => ({
              value: m.id,
              label: m.label
            }))}
            value={
              model
                ? {
                    value: model.id,
                    label: model.label
                  }
                : undefined
            }
            onChange={(val) => updateChooseModel(val.value)}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 100
              })
            }}
            isSearchable={false}
          />
        </div>
        {enableShowModelFitCheckbox() && (
          <div
            style={{ margin: "0px 20px", display: "flex", alignItems: "center" }}
            onClick={() => this.setState({ showModelFit: !this.state.showModelFit })}
          >
            <input style={{ margin: "0px" }} type="checkbox" checked={this.state.showModelFit} readOnly />
            <span style={{ marginLeft: "5px", marginTop: "2px" }}>{`Show Model Fit`}</span>
          </div>
        )}
        {isModelFrontier ? <span className={styles.frontierBadge}>{"Frontier"}</span> : ""}
        <div className={styles.allowFrontierHolder}>
          <span>{"Allow in Frontier"}</span>
          <Toggle
            checked={modelIsAllowedInFrontier}
            onChange={() => {
              if (model) {
                setIsAllowedInFrontier(model.id, !modelIsAllowedInFrontier);
                updateIgnoredModel(model.id, modelIsAllowedInFrontier);
              }
            }}
          />
        </div>
      </div>
    );
  }

  renderOverview() {
    const { id, projectId, hasSetupIgnoreChanged, isRetraining, retrainRun, models, runCost } = this.props;

    const { hideDetails } = this.state;

    const fids = this.generateFids();

    return (
      <div className={styles.chartHolder}>
        <div className={styles.chart + (hideDetails ? " " + styles.fullWidth : "")}>
          <div className={styles.chartLabel}>
            <div className={styles.chartTitle}>{"How each model performed"}</div>
          </div>
          <RunPlot
            forceEnableBts
            id={id}
            projectId={projectId}
            tableContainer={
              <MetaDataTable limitColumns={hideDetails ? undefined : 4} models={models} fids={fids} {...this.props} />
            }
            fids={fids}
            tableToggle={
              <Button onClick={() => this.setState({ hideDetails: !hideDetails })} style={{ width: "100%" }}>
                {hideDetails ? "Hide" : "Expand"}
              </Button>
            }
          />
        </div>
        <div className={styles.features + (hideDetails ? " " + styles.noWidth : "")}>
          <div className={styles.chartLabel}>
            <div className={styles.chartTitle}>{"Understand the selected model"}</div>
          </div>
          {this.renderFeatureChartHeader()}
          <div className={styles.fChart}>
            <FeatureChartContainer
              id={id}
              label={"Click to see more information about each variable"}
              predictMode={"drivers"}
              isResults
              isUnified
              fids={fids}
              onClick={() => this.updateSelectedTab(SECTIONS.PREDICTION_DRIVERS)}
              projectId={projectId}
              showModelFit={this.state.showModelFit}
            />
          </div>
        </div>
      </div>
    );
  }

  renderROIChart() {
    const { id, projectId, models, model } = this.props;

    return (
      <div className={styles.chartHolder}>
        <div className={styles.chartHolder}>
          <RunPlot forceEnableBts hideLineGraphs id={id} projectId={projectId} />
        </div>
      </div>
    );
  }

  getImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.displayImpact
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.displayImpact))
          : Math.round(model.maxIteration.displayImpact)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(isQuickRun ? model.meanAbsoluteError : model.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  getUnconstrainedImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.roi
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.roi))
          : Math.round(model.maxIteration.roi)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  handleSectionSelect(section) {
    const { model, updateFieldSelect, fieldSelect } = this.props;

    if (section === SECTIONS.PREDICTION_DRIVERS) {
      if (fieldSelect === undefined && model && model.featureInfo && model.featureInfo.length > 0) {
        updateFieldSelect(model.featureInfo[0].label);
      }
    }

    return this.updateSelectedTab(section);
  }

  getBestUnconstrainedModel(models) {
    let bestModel = null;
    let bestUnconstrainedImpact = 0;

    for (let m in models) {
      let unconstrainedImpact = this.getUnconstrainedImpactFromModel(models[m]);
      if (unconstrainedImpact > bestUnconstrainedImpact) {
        bestUnconstrainedImpact = unconstrainedImpact;
        bestModel = models[m];
      }
    }
    return bestModel;
  }

  renderResults() {
    const { id, model, isContinuous, isQuickRun, models, netImpactLabel, trueAction, isForceOptimized } = this.props;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1,
      justification: "L"
    };

    let nextModel = undefined;

    for (let i = 0; i < models.length; i++) {
      if (model.id === models[i].id) {
        if (i <= models.length - 1) {
          nextModel = models[i + 1];
        }
      }
    }

    const retNetImpactLabel = isContinuous
      ? isQuickRun && !isForceOptimized
        ? "Mean Absolute Error"
        : "Total Cost"
      : isQuickRun
        ? "Failure Count"
        : netImpactLabel;
    const retCapacityLabel = "Processed";

    const currentState =
      models && models.filter((m) => m.id === "Current State").length > 0
        ? models.filter((m) => m.id === "Current State")[0]
        : undefined;
    const winner = models && models.length > 0 ? models[0] : undefined;

    const winnerImpact = this.getImpactFromModel(winner);
    const impact = this.getImpactFromModel(model);
    const nextImpact = this.getImpactFromModel(nextModel);
    const currentStateImpact = this.getImpactFromModel(currentState);

    const unconstrainedCurrentStateImpact = this.getUnconstrainedImpactFromModel(currentState);
    const unconstrainedWinner = this.getBestUnconstrainedModel(models);
    const unconstrainedWinnerImpact = this.getUnconstrainedImpactFromModel(unconstrainedWinner);

    const processed = model && model.maxIteration ? Math.round((1 - model.maxIteration.processed) * 100) : undefined;
    const processMissed = model && model.maxIteration ? model.maxIteration.processMissed : undefined;
    const impactDiff = impact - currentStateImpact;

    const data = [
      {
        x: "Current State",
        [retNetImpactLabel]: currentStateImpact,
        color: "#F47C20"
      },
      {
        x: "Selected Model",
        [retNetImpactLabel]: impact,
        color: "rgb(81, 47, 119)",
        name: model.label
      },
      {
        x: "Winner",
        [retNetImpactLabel]: winnerImpact,
        color: "rgb(104, 87, 172)",
        name: winner ? winner.label : undefined
      },
      {
        x: "Best Unconstrained",
        [retNetImpactLabel]: unconstrainedWinnerImpact,
        color: "rgb(122, 109, 208)",
        name: nextModel ? nextModel.label + " (Unconstrained)" : undefined
      },
      {
        x: "Next Best",
        [retNetImpactLabel]: nextImpact,
        color: "rgb(140, 122, 228)",
        name: nextModel ? nextModel.label : undefined
      }
    ].filter(
      (d) => d[retNetImpactLabel] !== undefined && (currentStateImpact === undefined ? d.x !== "Current State" : true)
    );

    const unconstrainedData = [
      currentState
        ? {
            x: "Current State",
            [retCapacityLabel]: currentState.maxIteration.truePositive + currentState.maxIteration.falsePositive,
            color: "#F47C20"
          }
        : {},
      {
        x: "Selected Model",
        [retCapacityLabel]: model.maxIteration.truePositive + model.maxIteration.falsePositive,
        color: "rgb(81, 47, 119)",
        name: model.label
      },
      {
        x: "Winner",
        [retCapacityLabel]: winner.maxIteration.truePositive + winner.maxIteration.falsePositive,
        color: "rgb(104, 87, 172)",
        name: winner ? winner.label : undefined
      },
      {
        x: "Best Unconstrained",
        [retCapacityLabel]: unconstrainedWinner
          ? unconstrainedWinner.maxIteration.truePositive + unconstrainedWinner.maxIteration.falsePositive
          : undefined,
        color: "rgb(122, 109, 208)",
        name: nextModel ? nextModel.label + " (Unconstrained)" : undefined
      },
      {
        x: "Next Best",
        [retCapacityLabel]: nextModel
          ? nextModel.maxIteration.truePositive + nextModel.maxIteration.falsePositive
          : undefined,
        color: "rgb(140, 122, 228)",
        name: nextModel ? nextModel.label : undefined
      }
    ].filter(
      (d) =>
        d[retCapacityLabel] !== undefined &&
        (unconstrainedCurrentStateImpact === undefined ? d.x !== "Current State" : true)
    );

    return (
      <div className={styles.chartHolder}>
        <div className={styles.rSection}>
          {isContinuous ? (
            <div className={styles.info}>
              <div className={styles.infoHeader}>{isQuickRun ? "Mean Absolute Error" : "Total Cost"}</div>
              <div className={styles.infoNum}>
                <NumberLabel params={numberFormatParams}>{Math.abs(impact)}</NumberLabel>
              </div>
              {model && <div>{model.label}</div>}
            </div>
          ) : isQuickRun ? (
            <div className={styles.info}>
              <div className={styles.infoHeader}>{"Total Failure Count"}</div>
              <div className={styles.infoNum}>
                <NumberLabel params={numberFormatParams}>{Math.abs(impact)}</NumberLabel>
              </div>
              {model && <div>{model.label}</div>}
            </div>
          ) : currentState ? (
            <div className={styles.info}>
              <div className={styles.infoHeader}>{"Improvement"}</div>
              <div className={styles.infoNum}>
                {impactDiff > 0 ? (
                  <div className={styles.goodIcon}>
                    <FontAwesomeIcon icon={faArrowUp} />
                  </div>
                ) : (
                  <div className={styles.badIcon}>
                    <FontAwesomeIcon icon={faArrowDown} />
                  </div>
                )}
                <NumberLabel params={numberFormatParams}>{Math.abs(impactDiff)}</NumberLabel>
              </div>
              {currentState && <div>{impactDiff > 0 ? " more than current state" : " less than current state"}</div>}
            </div>
          ) : (
            <div className={styles.info}>
              <div>
                <div className={styles.info}>
                  <div className={styles.infoHeader}>{"Impact"}</div>
                  <div className={styles.infoNum}>&nbsp;</div>
                  <div>&nbsp;</div>
                </div>
              </div>
            </div>
          )}
          <div className={styles.resultsGraph}>
            <ResultsGraph data={data} netImpactLabel={retNetImpactLabel} />
          </div>
        </div>
        {!isQuickRun && !isContinuous && (
          <div style={{ height: "100%", width: "50%" }}>
            <div className={styles.info}>
              <div>
                <div className={styles.info}>
                  <div className={styles.infoHeader}>{"Resourcing"}</div>
                  <div className={styles.infoNum}>
                    <div className={styles.goodIcon}>
                      <FontAwesomeIcon icon={faArrowDown} />
                    </div>
                    {processMissed < 0 ? Math.round(Math.abs(processMissed * 100)) : processed + "%"}
                  </div>
                  <div>{"remaining capacity to " + trueAction}</div>
                </div>
              </div>
            </div>
            <div className={styles.resultsGraph}>
              <ResultsGraph data={unconstrainedData} netImpactLabel={retCapacityLabel} decimalScale={0} />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderPredictions() {
    const { id, models, projectId } = this.props;

    return (
      <div className={styles.chartHolder}>
        <FeatureChartContainer
          id={id}
          label={"Select to see more information about each variable"}
          isResults
          predictMode={"drivers"}
          projectId={projectId}
        />
      </div>
    );
  }

  renderWhatIf() {
    const { id, models, projectId } = this.props;

    return (
      <div className={styles.chartHolder}>
        <FeatureChartContainer id={id} isRecommend predictMode={"predict"} projectId={projectId} />
      </div>
    );
  }

  renderDetails() {
    const { id, models, model, frontierModels } = this.props;

    const fids = this.generateFids();

    return <MetaDataTable models={models} fids={fids} {...this.props} />;
  }

  getNameFromSegment(segment) {
    return segment && segment.conditions && segment.conditions.length > 0 ? segment.conditions[0].value : "";
  }

  renderOverall() {
    const {
      id,
      isNextStep,
      models,
      model,
      optimized,
      options,
      project,
      segments,
      modelGroups,
      projectId,
      blueprintId,
      isEditBlueprint,
      updateIsNextStep,
      isRetraining,
      runCost,
      isError,
      errorMessages,
      isFinalStep,
      updateCurrentStep,
      updateDrilldownValue
    } = this.props;

    const { isHelpClosed } = this.state;

    const fids = this.generateFids();

    return (
      <div className={styles.results}>
        <ProjectHelpContainer title={"Review the AI Model Performance for Each Subgroup"}>
          <ProjectHelpItem type={"chartScatter"}>
            {"The charts show detailed metrics on how well each model performed in the business scenario you created. "}
          </ProjectHelpItem>
          <ProjectHelpItem type={"award"}>
            {"The optimal AI is automatically selected to show the model drivers and details about its performance. "}
          </ProjectHelpItem>
        </ProjectHelpContainer>
        <div className={styles.resultsContent} style={isHelpClosed ? { height: "calc(100vh - 270px)" } : {}}>
          <div className={styles.totalSpentBox}>{"Total Spent: $" + (runCost ? runCost.toFixed(2) : "")}</div>
          <div className={styles.rightContent}>
            <div className={styles.eBotHeader}>
              <div className={styles.eBotHeaderItem}>{"Subgroup"}</div>
              <div className={styles.eBotHeaderItem}>{"How each model performed"}</div>
              <div className={styles.eBotHeaderItem}>{"Optimal Model"}</div>
              <div className={styles.eBotHeaderItem} style={{ justifyContent: "center" }}>
                {"Optimal Model Drivers"}
              </div>
            </div>
            <div className={styles.overallSection}>
              {modelGroups &&
                modelGroups.drilldownValues &&
                modelGroups.drilldownValues
                  .filter((s, i) => i !== 0)
                  .map((s, i) => {
                    const isContinuous =
                      s.bestModel && s.bestModel.maxIteration && s.bestModel.maxIteration.roi !== undefined
                        ? false
                        : true;

                    return (
                      <div className={styles.overallRow} key={i}>
                        <div className={styles.overallCol}>
                          <div
                            className={styles.bold}
                            style={{
                              marginBottom: "10px"
                            }}
                          >
                            {s.value}
                          </div>
                          <div className={styles.tSpentBox}>
                            {"Total Spent: $" + (s.runCost ? s.runCost.toFixed(2) : "")}
                          </div>
                          <div>
                            <Button onClick={() => updateDrilldownValue(s.runId, s.value)}>
                              {"View Subgroup Models"}
                            </Button>
                          </div>
                        </div>
                        <div className={styles.overallCol}>
                          <RunPlot forceEnableBts id={s.runId} projectId={projectId} hideLegend />
                        </div>
                        <div className={styles.overallCol}>
                          <div className={styles.mBold}>
                            <span className={styles.spanLabel}>{"Optimal Model:"}</span>
                            <span>{s.bestModel ? s.bestModel.label : "..."}</span>
                          </div>
                          {isContinuous !== true && (
                            <div className={styles.mBold}>
                              <span className={styles.spanLabel}>{"Threshold:"}</span>
                              <span>
                                {s.bestModel && s.bestModel.maxIteration
                                  ? (s.bestModel.maxIteration.threshold * 100).toFixed(2) + "%"
                                  : "..."}
                              </span>
                            </div>
                          )}
                          {isContinuous !== true && (
                            <div className={styles.mRunFrontier}>
                              <RunFrontierContainer id={s.runId} projectId={projectId} activeSegment={s.segment} />
                            </div>
                          )}
                          <div
                            style={{
                              marginTop: "10px"
                            }}
                          >
                            <div>{isContinuous === false ? "Business Impact" : "Error Cost"}</div>
                            <div className={styles.bold}>
                              {s.bestModel && s.bestModel.maxIteration && s.bestModel.maxIteration.roi !== undefined
                                ? "$" + numeral(s.bestModel.maxIteration.roi).format("0.0a")
                                : s.bestModel && s.bestModel.metrics && s.bestModel.metrics.overImpact !== undefined
                                  ? numeral(s.bestModel.metrics.overImpact + s.bestModel.metrics.underImpact).format(
                                      "0.0a"
                                    )
                                  : ""}
                            </div>
                          </div>
                        </div>
                        <div className={styles.overallCol}>
                          <div className={styles.chartHolder}>
                            <FeatureChartContainer
                              id={s.runId}
                              isHideSelect
                              predictMode={"predict"}
                              featureStyle={{
                                border: "none",
                                margin: "0px",
                                background: "white"
                              }}
                              isTabMini
                              isProjectOverview
                              projectId={projectId}
                              hideRight
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      isNextStep,
      models,
      model,
      optimized,
      options,
      blueprintId,
      isEditBlueprint,
      updateIsNextStep,
      isRetraining,
      runCost,
      isError,
      errorMessages,
      isFinalStep,
      updateCurrentStep
    } = this.props;

    const { isHelpClosed } = this.state;

    const fids = this.generateFids();

    const isLoading = optimized === undefined || optimized.isLoading || optimized.isCreating;

    if (isError && !this.getIsOverallSegment()) {
      return <ModelError errors={errorMessages} />;
    }

    if (isLoading || isRetraining) {
      return (
        <div className={styles.optimizerEmpty}>
          <div className={styles.loading}>
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "-20%",
                marginBottom: "50px",
                transform: "scale(1.75)"
              }}
            />
            <div className={styles.loadMsg}>
              {(optimized && optimized.isCreating) || isRetraining ? "Training AI Models..." : "Loading AI Models..."}
            </div>
          </div>
        </div>
      );
    }

    const sectionKey = options && options["selectedTab"];

    if (this.getIsOverallSegment() === true) {
      return this.renderOverall();
    }

    return (
      <div className={styles.results}>
        <div className={styles.totalSpentBox}>{"Total Spent: $" + (runCost ? runCost.toFixed(2) : "")}</div>
        <ProjectHelpContainer title={"Review the AI Model Performance"}>
          <ProjectHelpItem type={"chartScatter"}>
            {"The charts show detailed metrics on how well each model performed in the business scenario you created. "}
          </ProjectHelpItem>
          <ProjectHelpItem type={"award"}>
            {"The optimal AI is automatically selected to show the model drivers and details about its performance. "}
          </ProjectHelpItem>
          <ProjectHelpItem type={"info"}>
            {"Selecting a variable name will show additional insights around that model driver. "}
          </ProjectHelpItem>
        </ProjectHelpContainer>
        <div className={styles.resultsContent} style={isHelpClosed ? { height: "calc(100vh - 270px)" } : {}}>
          {/* {(sectionKey == SECTIONS.MODEL_DETAILS) | sectionKey ? (
						""
					) : (
						<div
							className={styles.miniHolder}
							style={
								sectionKey === SECTIONS.PREDICTION_DRIVERS ||
								sectionKey === SECTIONS.WHAT_IF
									? { width: "350px" }
									: {}
							}
						>
							<MiniContainer
								fids={fids}
								id={id}
								section={sectionKey}
							/>
						</div>
					)} */}
          <div className={styles.rightContent}>{this.renderOverview()}</div>
          {/* <div className={styles.rightContent}>
						{(sectionKey === SECTIONS.OVERVIEW ||
							sectionKey === undefined) &&
							this.renderOverview()}
						{sectionKey === SECTIONS.RESULTS &&
							this.renderResults()}
						{sectionKey === SECTIONS.ROI_CHART &&
							this.renderROIChart()}
						{sectionKey === SECTIONS.PREDICTION_DRIVERS &&
							this.renderPredictions()}
						{sectionKey === SECTIONS.WHAT_IF && this.renderWhatIf()}
						{sectionKey === SECTIONS.MODEL_DETAILS &&
							this.renderDetails()}
					</div> */}
        </div>
      </div>
    );
  }
}
